
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class ConvertToWIPGrid extends Serenity.EntityGrid<ConvertToWIPRow, any> {
        protected getColumnsKey() { return 'Inventory.ConvertToWIP'; }
        protected getDialogType() { return ConvertToWIPDialog; }
        protected getIdProperty() { return ConvertToWIPRow.idProperty; }
        protected getInsertPermission() { return ConvertToWIPRow.insertPermission; }
        protected getLocalTextPrefix() { return ConvertToWIPRow.localTextPrefix; }
        protected getService() { return ConvertToWIPService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(84);
            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[84].AutoPosting;
            this.editItem(<ConvertToWIPRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                VoucherTypeId: 84,
                TransDate: now.toDateString(),
                AutoPosting: autoposting
            });
        }
    }
}